const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export const getOptimizedImageUrl = (url, width = 800) => {
  if (!url || typeof url !== 'string') return url;
  const safeWidth = Math.min(Math.max(Number(width) || 800, 160), 1600);

  const makeOptimizedPath = (filename) => {
    const path = `/api/images/${encodeURIComponent(filename)}?w=${safeWidth}`;
    return process.env.NODE_ENV === 'development' ? path : `${BACKEND_URL}${path}`;
  };

  if (url.startsWith('/api/uploads/')) {
    return makeOptimizedPath(url.split('/').pop());
  }

  try {
    const parsed = new URL(url);
    if (parsed.pathname.startsWith('/api/uploads/')) {
      return `${parsed.origin}/api/images/${encodeURIComponent(parsed.pathname.split('/').pop())}?w=${safeWidth}`;
    }
  } catch {
    return url;
  }

  return url;
};
